import { observer } from 'mobx-react';

function Footer() {
  return (
    <div className="flex justify-center mt-6">
      <div className="h-8 w-[10%] bg-gray-300 rounded"></div>
    </div>
  );
}

export default observer(Footer);
